import React, { useState } from 'react';
import styled from 'styled-components';
import { MainLayout, InnerLayout } from '../styles/Layouts';
import Title from '../Components/Title';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContactItem from '../Components/ContactItem';
import Alert from '../Components/Alert';
import Particle from '../Components/Particle';
import { init, send } from 'emailjs-com';
init('user_CciAwlTl987lwIMGjWrvP');

function ContactPage() {
  const phone = <PhoneIcon />;
  const email = <EmailIcon />;
  const location = <LocationOnIcon />;

  const [alert, setAlert] = useState({ show: true, msg: '', type: '' });
  const [toSend, setToSend] = useState('');

  const showAlert = (show = true, type = '', msg = '') => {
    setAlert({ show, type, msg });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    if (!toSend) {
      showAlert(true, 'danger', 'Oops! Something went wrong, try to fill again');
    } else {
      setToSend({
        from_name: '',
        from_email: '',
        subject: '',
        message: '',
      });
      send('service_1l59ixm', 'template_jq8fdqh', toSend, 'user_CciAwlTl987lwIMGjWrvP')
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
        })
        .catch((err) => {
          console.log('FAILED...', err);
        });
      setToSend({ from_name: '', from_email: '', subject: '', message: '' });

      showAlert(true, 'success', 'Message Send, I will reply as soon as Possible');
    }
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  return (
    <MainLayout>
      <Title title={'Contact'} span={'Contact'} />
      <ContactPageStyled>
        <InnerLayout className={'contact-section'}>
          <div className="left-content">
            <Particle />
            <div className="contact-title">
              <h4>Get In Touch</h4>
            </div>

            <form className="form" onSubmit={onSubmit}>
              <div className="form-field">
                <label htmlFor="name">Enter your name*</label>
                <input type="text" id="name" name="from_name" value={toSend.from_name} onChange={handleChange} />
              </div>
              <div className="form-field">
                <label htmlFor="email">Enter your email*</label>
                <input type="email" id="email" name="from_email" value={toSend.from_email} onChange={handleChange} />
              </div>
              <div className="form-field">
                <label htmlFor="subject">Enter your subject</label>
                <input type="text" id="subject" name="subject" value={toSend.subject} onChange={handleChange} />
              </div>
              <Particle />
              <div className="form-field">
                <label htmlFor="text-area">Enter your Message*</label>
                <textarea
                  name="message"
                  value={toSend.message}
                  onChange={handleChange}
                  id="textarea"
                  cols="30"
                  rows="10"
                ></textarea>
              </div>

              {alert.show && <Alert {...alert} removeAlert={showAlert} />}
              <div className="form-field f-button">
                <button type="submit" className="btn btn-primary">
                  Send
                </button>
              </div>
            </form>
          </div>
          <div className="right-content">
            <Particle />
            <ContactItem title={'Phone'} icon={phone} cont1={'+351 961124750'} />
            <ContactItem title={'Email'} icon={email} cont1={'pedrogroug@gmail.com'} />
            <ContactItem title={'Address'} icon={location} cont1={'6000, Castelo Branco, Portugal'} cont2={'Europe'} />
          </div>
        </InnerLayout>
      </ContactPageStyled>
    </MainLayout>
  );
}

const ContactPageStyled = styled.section`
  .contact-section {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 2rem;
    @media screen and (max-width: 978px) {
      grid-template-columns: repeat(1, 1fr);
      .f-button {
        margin-bottom: 3rem;
      }
    }
    .right-content {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(1, 1fr);
    }
    .contact-title {
      h4 {
        color: var(--white-color);
        padding: 1rem 0;
        font-size: 1.8rem;
      }
    }
    .form {
      width: 100%;

      @media screen and (max-width: 502px) {
        width: 100%;
      }
      @media screen and (max-width: 430px) {
        width: 85%;
      }

      button {
        background-color: var(--background-dark-color);
        padding: 0.7rem 2.5rem;
        color: var(--font-light-color);
        cursor: pointer;
        display: inline-block;
        font-size: inherit;
        text-transform: uppercase;
        position: relative;
        transition: all 0.4s ease-in-out;
        border-radius: 50px;
        border: 2px solid var(--border-color);

        &:hover {
          border: 2px solid var(--primary-color);
          border-radius: 50px;
        }
      }

      .form-field {
        margin-top: 2rem;
        position: relative;
        width: 100%;
        label {
          position: absolute;
          left: 20px;
          top: -20px;
          display: inline-block;
          background-color: var(--background-dark-color);
          padding: 0 0.5rem;
          color: inherit;
        }
        input {
          border: 1px solid var(--border-color);
          outline: none;
          background: transparent;
          height: 50px;
          padding: 0 15px;
          width: 100%;
          color: inherit;
          border-radius: 10px;
        }
        textarea {
          background-color: transparent;
          border: 1px solid var(--border-color);
          outline: none;
          color: inherit;
          width: 100%;
          padding: 0.8rem 1rem;
          border-radius: 10px;
        }
      }
    }
  }
`;

export default ContactPage;
